import { styled } from '@attentive-platform/stem-ui';

export const TatConsoleStyles = {
  Block: styled('div')(() => ({
    padding: '14px 16px',
    borderBottom: '1px solid #EBEBEB',
    background: '#FCFCFD',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  })),
  TopRow: styled('div')(() => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '14px',
    flexWrap: 'wrap'
  })),
  Left: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    minWidth: 0,
    flex: '1 1 320px'
  })),
  Eyebrow: styled('span')(() => ({
    fontSize: '11px',
    color: '#9E9E9E',
    letterSpacing: '.04em',
    textTransform: 'uppercase'
  })),
  TitleRow: styled('div')(() => ({
    display: 'flex',
    alignItems: 'baseline',
    gap: '8px',
    flexWrap: 'wrap'
  })),
  Title: styled('span')(() => ({
    fontSize: '14.5px',
    fontWeight: 600,
    whiteSpace: 'nowrap'
  })),
  Tier: styled('span')(() => ({
    fontSize: '12px',
    color: '#808080',
    whiteSpace: 'nowrap'
  })),
  Reason: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#4D4D4D',
    lineHeight: 1.5,
    fontStyle: 'italic'
  })),
  InPlaceOf: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#4D4D4D'
  })),
  PresetLine: styled('span')(() => ({
    fontSize: '13px',
    color: '#4D4D4D'
  })),
  Warn: styled('span')(() => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '7px',
    alignSelf: 'flex-start',
    fontSize: '12px',
    fontWeight: 500,
    color: '#8A6A00',
    background: '#FFFBF0',
    border: '1px solid #FFE9B8',
    borderRadius: '6px',
    padding: '3px 9px',
    marginTop: '2px'
  })),
  WarnDot: styled('span')(() => ({
    width: '6px',
    height: '6px',
    borderRadius: '3px',
    background: '#E0A800',
    flex: 'none'
  })),
  Actions: styled('div')(() => ({
    display: 'flex',
    gap: '6px',
    flex: 'none'
  })),
  NoCard: styled('span')(() => ({
    fontSize: '13.5px',
    fontWeight: 500,
    color: '#666666'
  })),
  NoCardHint: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#9E9E9E'
  })),
  Cells: styled('div', { shouldForwardProp: p => p !== '$cols' })(({ $cols }) => ({
    display: 'grid',
    gridTemplateColumns: `repeat(${$cols || 7}, minmax(0, 1fr))`,
    gap: '5px'
  })),
  Cell: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2px',
    padding: '7px 4px',
    borderRadius: '8px',
    border: '1px solid #EBEBEB',
    background: '#FFFFFF'
  })),
  CellRange: styled('span')(() => ({
    fontSize: '11px',
    color: '#808080',
    whiteSpace: 'nowrap'
  })),
  CellVal: styled('span', { shouldForwardProp: p => p !== '$quote' })(({ $quote }) => ({
    fontSize: '15px',
    fontWeight: 600,
    color: $quote ? '#995C00' : '#212121',
    fontVariantNumeric: 'tabular-nums'
  })),
  Foot: styled('span')(() => ({
    fontSize: '11.5px',
    color: '#9E9E9E'
  })),

  // Modals
  Overlay: styled('div')(() => ({
    position: 'fixed',
    inset: 0,
    background: 'rgba(4,12,47,.36)',
    zIndex: 125
  })),
  Modal: styled('div')(() => ({
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '620px',
    maxWidth: 'calc(100vw - 48px)',
    maxHeight: '88vh',
    overflow: 'auto',
    background: '#FFFFFF',
    borderRadius: '14px',
    boxShadow: '0 26px 64px rgba(9,24,93,.26)',
    zIndex: 126,
    display: 'flex',
    flexDirection: 'column'
  })),
  ModalSm: styled('div')(() => ({
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '520px',
    maxWidth: 'calc(100vw - 48px)',
    background: '#FFFFFF',
    borderRadius: '14px',
    boxShadow: '0 26px 64px rgba(9,24,93,.26)',
    zIndex: 126,
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '14px'
  })),
  ModalHead: styled('div')(() => ({
    padding: '20px 24px 14px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    borderBottom: '1px solid #EBEBEB'
  })),
  ModalTitle: styled('span')(() => ({
    fontSize: '18px',
    fontWeight: 600,
    letterSpacing: '-0.005em'
  })),
  ModalSub: styled('span')(() => ({
    fontSize: '13px',
    color: '#666666',
    lineHeight: 1.5
  })),
  ModalBody: styled('div')(() => ({
    padding: '18px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  })),
  ModalFoot: styled('div')(() => ({
    padding: '14px 24px 20px',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
    borderTop: '1px solid #EBEBEB'
  })),
  FieldLabel: styled('span')(() => ({
    fontSize: '13px',
    fontWeight: 500,
    color: '#4D4D4D'
  })),
  Req: styled('span')(() => ({
    color: '#C1180B'
  })),
  FieldsGrid: styled('div', { shouldForwardProp: p => p !== '$cols' })(({ $cols }) => ({
    display: 'grid',
    gridTemplateColumns: `repeat(${$cols || 7}, minmax(0, 1fr))`,
    gap: '6px'
  })),
  FieldCol: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  })),
  DayInput: styled('input', { shouldForwardProp: p => p !== '$bad' })(({ $bad }) => ({
    fontFamily: 'inherit',
    fontSize: '14px',
    fontWeight: 600,
    textAlign: 'center',
    color: '#212121',
    background: '#FFFFFF',
    border: `1.5px solid ${$bad ? '#F0B4AE' : '#E0E0E0'}`,
    borderRadius: '8px',
    padding: '8px 4px',
    width: '100%'
  })),
  Was: styled('span')(() => ({
    fontSize: '10.5px',
    color: '#9E9E9E',
    textAlign: 'center'
  })),
  FieldError: styled('span')(() => ({
    fontSize: '12px',
    color: '#C1180B'
  })),
  Hint: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#808080'
  })),
  Footnote: styled('div')(() => ({
    display: 'flex',
    gap: '10px',
    alignItems: 'flex-start',
    background: '#FAFAFA',
    border: '1px solid #F0F0F0',
    borderRadius: '10px',
    padding: '11px 13px'
  })),
  FootnoteDot: styled('span')(() => ({
    width: '6px',
    height: '6px',
    borderRadius: '3px',
    background: '#A2B1F6',
    marginTop: '6px',
    flex: 'none'
  })),
  TextArea: styled('textarea')(() => ({
    fontFamily: 'inherit',
    fontSize: '13.5px',
    lineHeight: 1.5,
    color: '#212121',
    border: '1px solid #E0E0E0',
    borderRadius: '8px',
    padding: '10px 12px',
    width: '100%',
    resize: 'vertical',
    minHeight: '72px'
  })),

  // Compare
  CompareModal: styled('div')(() => ({
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '640px',
    maxWidth: 'calc(100vw - 48px)',
    maxHeight: '82vh',
    background: '#FFFFFF',
    borderRadius: '14px',
    boxShadow: '0 26px 64px rgba(9,24,93,.26)',
    zIndex: 121,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  })),
  CompareHead: styled('div')(() => ({
    flex: 'none',
    padding: '20px 24px 16px',
    borderBottom: '1px solid #EBEBEB',
    display: 'flex',
    flexDirection: 'column',
    gap: '14px'
  })),
  CompareBody: styled('div')(() => ({
    flex: 1,
    minHeight: 0,
    overflow: 'auto',
    padding: '18px 24px 22px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  })),
  CompareClass: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  })),
  CompareClassTitle: styled('span')(() => ({
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: '.04em',
    textTransform: 'uppercase',
    color: '#808080'
  })),
  CompareLine: styled('div')(() => ({
    display: 'flex',
    gap: '8px',
    fontSize: '13.5px',
    lineHeight: 1.45,
    color: '#212121'
  })),
  CompareMark: styled('span', { shouldForwardProp: p => p !== '$color' })(({ $color }) => ({
    color: $color || '#112FBB',
    fontWeight: 600,
    flex: 'none'
  })),
  Summary: styled('span')(() => ({
    fontSize: '13px',
    color: '#4D4D4D'
  })),

  // Cards tab
  CardsWrap: styled('div')(() => ({
    padding: '20px 24px 40px',
    display: 'flex',
    flexDirection: 'column',
    gap: '14px'
  })),
  CardsHeader: styled('div')(() => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '16px',
    flexWrap: 'wrap'
  })),
  CardsTitleBlock: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '3px',
    flex: '1 1 280px',
    minWidth: '240px'
  })),
  CardsTitle: styled('h1')(() => ({
    margin: 0,
    fontSize: '22px',
    fontWeight: 600,
    letterSpacing: '-0.01em'
  })),
  CardsSub: styled('span')(() => ({
    fontSize: '13.5px',
    color: '#666666',
    lineHeight: 1.5
  })),
  CardsCount: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#808080'
  })),
  TradeBlock: styled('div')(() => ({
    border: '1px solid #EBEBEB',
    borderRadius: '12px',
    overflow: 'hidden'
  })),
  TradeHead: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    padding: '12px 16px',
    background: '#FAFAFA',
    borderBottom: '1px solid #EBEBEB',
    flexWrap: 'wrap'
  })),
  TradeHeadLeft: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap'
  })),
  TradeName: styled('span')(() => ({
    fontSize: '15px',
    fontWeight: 600
  })),
  TradeMeta: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#808080'
  })),
  OwnRanges: styled('span')(() => ({
    fontSize: '11.5px',
    fontWeight: 500,
    color: '#4D4D4D',
    background: '#F5F5F5',
    border: '1px solid #EBEBEB',
    borderRadius: '999px',
    padding: '2px 9px'
  })),
  TradeBody: styled('div')(() => ({
    display: 'grid',
    gridTemplateColumns: 'minmax(260px, 1fr) minmax(0, 2fr)',
    gap: 0,
    '@media (max-width: 900px)': {
      gridTemplateColumns: '1fr'
    }
  })),
  PresetsCol: styled('div')(() => ({
    padding: '14px 16px',
    borderRight: '1px solid #F0F0F0',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    '@media (max-width: 900px)': {
      borderRight: 'none',
      borderBottom: '1px solid #F0F0F0'
    }
  })),
  CardsCol: styled('div')(() => ({
    padding: '14px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    minWidth: 0,
    overflowX: 'auto'
  })),
  PresetRow: styled('div')(() => ({
    display: 'flex',
    gap: '10px',
    alignItems: 'flex-start'
  })),
  Rung: styled('span')(() => ({
    width: '20px',
    height: '20px',
    borderRadius: '10px',
    background: '#F0F0F0',
    color: '#4D4D4D',
    fontSize: '11px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 'none',
    marginTop: '1px'
  })),
  PresetBody: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '3px',
    minWidth: 0
  })),
  PresetNameRow: styled('div')(() => ({
    display: 'flex',
    alignItems: 'baseline',
    gap: '8px',
    flexWrap: 'wrap'
  })),
  PresetName: styled('span')(() => ({
    fontSize: '13.5px',
    fontWeight: 600
  })),
  PresetCard: styled('span')(() => ({
    fontSize: '12px',
    color: '#808080',
    whiteSpace: 'nowrap'
  })),
  PresetDesc: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#4D4D4D',
    lineHeight: 1.45
  })),
  AddsBtn: styled('button')(() => ({
    alignSelf: 'flex-start',
    fontSize: '12px',
    fontWeight: 500,
    color: '#163CE9',
    background: 'none',
    border: 0,
    padding: 0,
    cursor: 'pointer',
    fontFamily: 'inherit'
  })),
  AddsNames: styled('span')(() => ({
    fontSize: '12px',
    color: '#4D4D4D',
    lineHeight: 1.5
  })),
  TableHead: styled('div', { shouldForwardProp: p => p !== '$cols' })(({ $cols }) => ({
    display: 'grid',
    gridTemplateColumns: `170px 104px repeat(${$cols || 7}, minmax(56px, 1fr)) 150px`,
    gap: '6px',
    alignItems: 'center'
  })),
  TableHeadLabel: styled('span')(() => ({
    fontSize: '11px',
    color: '#9E9E9E',
    letterSpacing: '.04em',
    textTransform: 'uppercase'
  })),
  TableRange: styled('span')(() => ({
    fontSize: '11px',
    color: '#808080',
    textAlign: 'center',
    whiteSpace: 'nowrap'
  })),
  CardBlock: styled('div', { shouldForwardProp: p => p !== '$cols' })(({ $cols }) => ({
    display: 'grid',
    gridTemplateColumns: `170px 104px repeat(${$cols || 7}, minmax(56px, 1fr)) 150px`,
    gap: '6px',
    alignItems: 'center',
    padding: '9px 0',
    borderTop: '1px solid #F5F5F5'
  })),
  CardName: styled('span')(() => ({
    fontSize: '13.5px',
    fontWeight: 600
  })),
  RowLabel: styled('span', { shouldForwardProp: p => p !== '$muted' })(({ $muted }) => ({
    fontSize: '12px',
    fontWeight: 500,
    color: $muted ? '#808080' : '#212121'
  })),
  DayCell: styled('span', {
    shouldForwardProp: p => !['$quote', '$internal', '$bg'].includes(p)
  })(({ $quote, $internal, $bg }) => ({
    textAlign: 'center',
    fontSize: '13px',
    fontWeight: $internal ? 500 : 600,
    color: $quote ? ($internal ? '#BDBDBD' : '#995C00') : $internal ? '#666666' : '#212121',
    background: $bg || 'transparent',
    borderRadius: '6px',
    padding: '4px 2px'
  })),
  Applies: styled('span')(() => ({
    fontSize: '12px',
    color: '#4D4D4D'
  })),
  VersionSelect: styled('select')(() => ({
    fontFamily: 'inherit',
    fontSize: '12px',
    border: '1px solid #E0E0E0',
    borderRadius: '6px',
    padding: '4px 6px',
    width: '100%',
    color: '#4D4D4D',
    background: '#FFFFFF'
  })),
  ReadOnlyNote: styled('span')(() => ({
    fontSize: '11px',
    color: '#9E9E9E'
  })),
  Empty: styled('span')(() => ({
    fontSize: '13.5px',
    color: '#808080',
    padding: '24px 0'
  }))
};
